module.exports = (__webpack_require__(1))(189);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/AssetstoresView.js from dll-reference girder_lib
// module id = 10
// module chunks = 0